var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title.text)?_c(_vm.resolver[_vm.title.type],{tag:"component",staticClass:"global-title",style:({ color: _vm.textColor }),domProps:{"innerHTML":_vm._s(_vm.lineFeed)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }